var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-list"},[_c('Overlay',{attrs:{"width":"large","link":{
      name: 'page',
      params: {
        companyId: this.companyId,
        siteId: this.siteId,
        pageId: this.pageId
      }
    }}},[_c('div',{staticClass:"create-content"},[_c('div',{staticClass:"widget-fields-wrapper"},[_c('add-list-form',{attrs:{"errors":_vm.errors,"list-types":_vm.sortedListTypeOptions,"pageName":_vm.pageName,"btnLoading":_vm.btnLoading,"totalLists":_vm.lists.length},on:{"submit":_vm.submitList,"typeChange":_vm.handleTypeChange},model:{value:(_vm.list),callback:function ($$v) {_vm.list=$$v},expression:"list"}})],1),_c('div',{staticClass:"widget-preview-wrapper"},[_c('WidgetPreviewer',{attrs:{"demoMode":true,"listType":_vm.listType,"listItem":_vm.listItem,"listItems":_vm.demoData}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }